/* eslint-disable react/prop-types */
import DialingSuccess from 'components/modules/dashboard/DialingSuccess';
import { Col, Row } from 'react-bootstrap';
import ActualCallingKPIs from 'pages/hvamanagement/ActualCallingKPIs';
import ActualCallingKPIsInbound from 'pages/hvamanagement/ActualCallingKPIsInbound';
import DialingPerformanceChart from 'components/charts/DialingPerformanceChart';
import DialingPerformanceChartInbound from 'components/charts/DialingPerformanceChartInbound';
import CampaignTodayPerformance from 'pages/hvamanagement/CampaignTodayPerformance';
import CampaignTodayPerformanceInbound from 'pages/hvamanagement/CampaignTodayPerformanceInbound';

interface CampaignTodayCallingProps {
  campaignid: number;
  campaignType?: 'outbound' | 'inbound';
}

const CampaignTodayCalling: React.FC<CampaignTodayCallingProps> = ({
  campaignid,
  campaignType = 'outbound'
}) => {
  return (
    <>
      <>
        {/* Para campañas inbound y outbound */}
        <Row className="mb-1 px-3 gy-6">
          <h4 className="mb-0 p-0 text-body-emphasis">Inbound KPI's</h4>
        </Row>
        <Row className="mb-0 pt-0 px-3 gy-6">
          <Col xs={12} sm={12} md={5} xl={3} xxl={3}>
            <ActualCallingKPIsInbound campaignid={campaignid} />
          </Col>
          <Col xs={12} sm={12} md={7} xl={9} xxl={9} className="p-6 pt-2 pb-0">
            <h5>Call Handling</h5>
            <p className="text-body-tertiary fs-10 mb-0">
              Offered &amp; handled
            </p>
            <DialingPerformanceChartInbound
              campaignid={campaignid.toString()}
            />
          </Col>
        </Row>
      </>
      {/* Para campañas outbound */}
      {campaignType === 'outbound' && (
        <>
          <Row className="mb-1 px-3 gy-6">
            <h4 className="mb-0 p-0 text-body-emphasis">Outbound KPI's</h4>
          </Row>
          <Row className="mb-3 pt-0 px-3 gy-6">
            <Col xs={12} sm={12} md={5} xl={3} xxl={3}>
              <ActualCallingKPIs campaignid={campaignid} />
            </Col>
            <Col
              xs={12}
              sm={12}
              md={7}
              xl={9}
              xxl={9}
              className="p-6 pt-2 pb-0"
            >
              <h5>Dialing success</h5>
              <p className="text-body-tertiary fs-10 mb-0">
                Dialing &amp; answers
              </p>
              <DialingPerformanceChart campaignid={campaignid.toString()} />
            </Col>
          </Row>
          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 mb-0">
            <Row>
              <Col lg={12} xl={4} xxl={4}>
                <DialingSuccess
                  title="Dialing success last 30 minutes"
                  value={1}
                  campaign={campaignid}
                />
              </Col>
              <Col lg={12} xl={4} xxl={4}>
                <DialingSuccess
                  title="Dialing success last hour"
                  value={2}
                  campaign={campaignid}
                />
              </Col>
              <Col lg={12} xl={4} xxl={4}>
                <DialingSuccess
                  title="Dialing success today"
                  value={3}
                  campaign={campaignid}
                />
              </Col>
            </Row>
          </div>
        </>
      )}
      <>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-3 mb-3">
          <Row>
            <Col xs={12} xl={12} xxl={12}>
              <CampaignTodayPerformanceInbound campaignid={campaignid} />
            </Col>
          </Row>
        </div>
      </>
      {/* Para campañas outbound */}
      {campaignType === 'outbound' && (
        <>
          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 mb-0">
            <Row>
              <Col xs={12} xl={12} xxl={12}>
                <CampaignTodayPerformance campaignid={campaignid} />
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
};

export default CampaignTodayCalling;
